(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  const elements = [...document.querySelectorAll('[data-parallax]')];
  let ticking = false;
  const update = () => {
    const viewportCenter = window.innerHeight / 2;
    elements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const speed = Number(element.dataset.parallax || 0);
      const distance = rect.top + rect.height / 2 - viewportCenter;
      element.style.transform = `translate3d(0, ${distance * speed * -1}px, 0)`;
    });
    ticking = false;
  };
  const requestUpdate = () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } };
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  requestUpdate();
})();
